import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { AdminPage } from '@/features/admin';

function AdminRoute(): ReactNode {
  return (
    <AuthGuard>
      <AdminPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/admin')({
  component: AdminRoute,
});
